{
  "Use AirPlay": "Usa AirPlay"
}
